import { gql, useMutation } from '@apollo/client';
import { ActivityDayAvailability, MutationSetActivityAvailabilityArgs } from './types';

const SET_ACTIVITY_AVAILABILITY = gql`
  mutation setActivityAvailability($input: SetActivityAvailabilityInput!) {
    setActivityAvailability(input: $input) {
      day
      isOpen
    }
  }
`;

const useSetActivityAvailabilityMutation = () => {
  return useMutation<
    { setActivityAvailability: ActivityDayAvailability[] },
    MutationSetActivityAvailabilityArgs
  >(SET_ACTIVITY_AVAILABILITY, {});
};

export default useSetActivityAvailabilityMutation;
